function getBaseUrl() {
  return "".concat(window.location.pathname).concat(window.location.search);
}
export default getBaseUrl;